












































import {
  Vue,
  Component,
  Watch,
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import moment from "moment";
import _ from "lodash";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useContributionStore } from "@/shared/store/contribution";
import { useHsaTotalStore } from "@/shared/store/hsaTotal";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useHsaLimitStore } from "@/shared/store/hsalimit";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class OtherContributionForm extends Vue {
  $validator: Validator;
  contributionStore = useContributionStore();
  hsaTotalStore = useHsaTotalStore();
  custodianSettingsStore = useCustodianSettingsStore();
  otherHsaAmountFormBackingField = 0;
  selectedYear = this.currentYearClock;
  hsaLimitStore = useHsaLimitStore();

  mounted (): void {
    this.hsaLimitStore.getHsaAccountLimits();
    this.contributionStore.getOtherHsaPriorYearCutoffDate();
    if (!this.hsaTotalStore.isLoaded) {
      this.hsaTotalStore.getUserPayrollSummary();
    } else {
      this.updateFromStore();
    }
  }

  @Watch("hsaTotalStore.isLoaded")
  onLoaded () {
    if (this.hsaTotalStore.isLoaded) {
      this.updateFromStore();
    }
  }

  isSubmitting = false;

  onSubmit () {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }
      if (this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;
      return this.hsaTotalStore.updateOtherHsa({ amount: this.otherHsaAmountFormBackingField, year: this.selectedYear })
          .then(() => {
            this.hsaTotalStore.reload(true);
          }).catch(() => {
            // no-op
          })
          .finally(() => {
            this.isSubmitting = false;
          });
    });
  }

  get disableSubmit () {
    return this.disableOtherHsaAmount;
  }

  updateFromStore () {
    this.otherHsaAmountFormBackingField = this.hsaTotalStore.otherHsaAmount(this.selectedYear);
  }

  get currentYearClock () {
    return moment().year();
  }

  yearsThrough (year: number): number[] {
    return _.range(this.contributionStore.firstPlanEffectiveYear, year + 1); // (from,to]
  }

  get contributionYearOptionsActualOnly () {
    return this.yearsThrough(this.currentYearClock);
  }

  get yearOptions () {
    if (this.custodianSettingsStore.isHsaBankCustodian) {
      return this.unfilteredYearOptions.filter(y => y >= 2022);
    }

    return this.unfilteredYearOptions;
  }

  get unfilteredYearOptions () {
    return this.contributionYearOptionsActualOnly;
  }

  get updateLabel () {
    return this.selectedYear === this.currentYearClock - 1
    && this.contributionStore.otherHsaPriorYearCutoffDate as any > moment().date
        ? "Update your Other HSA contributions amount until " +
        moment(this.contributionStore.otherHsaPriorYearCutoffDate).format("MM/DD/YYYY")
        : this.selectedYear === this.currentYearClock
            ? "Update your Other HSA contributions amount."
            : "Your Other HSA contributions amount.";
  }

  get disableOtherHsaAmount (): boolean {
    return this.isSubmitting
        || (this.selectedYear < this.currentYearClock && this.contributionStore.otherHsaPriorYearCutoffDate as any <
            moment().date);
  }

  get validateOtherHsaAmount (): any {
    const minimum = 0;
    const maximum = this.hsaLimitStore.getHsaLimitByYear(this.selectedYear);

    return {
      required: true,
      decimal: 2,
      min_value_usd: minimum,
      max_value_usd: maximum
    };
  }

  handleYearChange (value): void {
    this.selectedYear = value;
    this.updateFromStore();
  }
}
